var _defs, _path, _path2, _path3, _path4, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.531,
    height: 56,
    viewBox: "0 0 57.531 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2022",
    d: "M 17.083,1 H 9.448 A 8.448,8.448 0 0 0 1,9.448 v 7.636",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2024",
    d: "m 1,38.916 v 7.636 a 8.448,8.448 0 0 0 8.448,8.445 h 7.636",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2026",
    d: "M 56.528,17.083 V 9.448 A 8.448,8.448 0 0 0 48.083,1 h -7.636",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2029",
    d: "m 40.447,54.997 h 7.636 a 8.448,8.448 0 0 0 8.445,-8.445 v -7.636",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(7.515722)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linie_16",
    x1: 35.332275,
    y2: 28,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    y1: 28,
    x2: 8.8049564
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "translate(0,-1.7255744)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_16-5",
    x1: 22.920172,
    y2: 30.430269,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    y1: 15.577896,
    x2: 8.0677948,
    style: {
      stroke: "currentColor",
      strokeOpacity: 1
    }
  }), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Linie_16-5-2",
    x1: 8.0682716,
    y2: 43.873253,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    y1: 29.020882,
    x2: 22.920643
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3a924164f7b70f684748a095495893fe.svg";
export { ForwardRef as ReactComponent };